import { render, staticRenderFns } from "./move-bin.vue?vue&type=template&id=6d8ef9c8&scoped=true&"
import script from "./move-bin.vue?vue&type=script&lang=js&"
export * from "./move-bin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ef9c8",
  null
  
)

export default component.exports